import { useEffect, useState } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Button,
  List,
  ListItem,
  ListIcon,
  Text,
} from "@chakra-ui/react";
import { Check } from "../../../shared/icons";
import { PLANO_BLOQUEADO_EVENT } from "../../../shared/api/planoBloqueado";
import SubscribeButton from "./SubscribeButton";

const BENEFICIOS = [
  "Vínculos ilimitados, com previsão de pagamento de cada tomador",
  "Alertas de atraso e calendário de recebimentos",
  "Preço Fundador travado enquanto a assinatura estiver ativa",
];

// Abre quando alguma gravação responde 402 (ver shared/api/planoBloqueado): em vez de só
// um toast de erro, mostra o motivo que o backend mandou e o caminho para assinar.
export default function PlanoBloqueadoModal() {
  const [mensagem, setMensagem] = useState(null);

  useEffect(() => {
    const abrir = (event) => setMensagem(event.detail?.mensagem || "");
    window.addEventListener(PLANO_BLOQUEADO_EVENT, abrir);
    return () => window.removeEventListener(PLANO_BLOQUEADO_EVENT, abrir);
  }, []);

  const fechar = () => setMensagem(null);

  return (
    <Modal isOpen={mensagem !== null} onClose={fechar} isCentered size="md">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Assine para continuar registrando</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          {mensagem ? (
            <Text fontSize="sm" color="app-muted-fg" mb={4}>
              {mensagem}
            </Text>
          ) : null}
          <List spacing={2}>
            {BENEFICIOS.map((beneficio) => (
              <ListItem key={beneficio} display="flex" alignItems="flex-start" fontSize="sm">
                <ListIcon as={Check} color="success.500" mt="2px" />
                {beneficio}
              </ListItem>
            ))}
          </List>
        </ModalBody>
        <ModalFooter gap={3}>
          <Button variant="ghost" onClick={fechar}>
            Agora não
          </Button>
          <SubscribeButton origin="bloqueio_402" size="md" />
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
